import log from "@/common/log";
import axios from "axios"

const taxApiStatus = {
    canceled: false,
    lastResult: null
};

const taxRequestAbortController = new AbortController();

window.taxApiStatus = taxApiStatus;

const fetchEstimateTax = (data) => {
    if(taxApiStatus.canceled) return Promise.reject('estimate api is locked.');
    return axios.post('/opc/tax/estimate', data, {
        signal: taxRequestAbortController.signal
    }).then(res => {
        taxApiStatus.lastResult = res;
        return res;
    });
};

export function lockAndCancelTaxApi() {
    taxRequestAbortController.abort();
    taxApiStatus.canceled = true;
}

export const estimateTax = (data) => {
    return fetchEstimateTax(data).catch((err) => {
        log('error', err)
        return Promise.resolve(taxApiStatus.lastResult)
    });
};
